<template>
  <div class="c-company">
    <h1 class="c-users-information__title">{{ $t('usersInformation.company.title') }}</h1>
    <p class="c-users-information__text">{{ $t('usersInformation.company.text') }}</p>
    <!-- row-1 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.company.name') }}</label>
      <p4a-input
        :placeholder="companyName"
        :type="'text'"
        :size="'small'"
        :disabled="true"
      />
    </div>
    <!-- row-2 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.company.function') }}</label>
      <p4a-input
        :value="companyPosition"
        @input="$emit('update:companyPosition', $event)"
        :type="'text'"
        :size="'small'"
        :leftIcon="''"
        :autofocus="true"
      />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    companyName: {
      type: String
    },
    companyPosition: {
      type: String
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/userControls/management/usersInformation/company.vue